import { createFileRoute } from "@tanstack/react-router"
import { ManufacturerDetail } from "@/components/sensory"

export const Route = createFileRoute("/sensory/manufacturers/$manufacturerNumber")({
  staticData: {
    title: 'Manufacturer Detail',
    isSecured: true,
  },
  component: ManufacturerDetailPage,
})

function ManufacturerDetailPage() {
  const { manufacturerNumber } = Route.useParams()

  return (
    <div className="p-6">
      <ManufacturerDetail manufacturerNumber={parseInt(manufacturerNumber)} />
    </div>
  )
}
